<template>
  <div class="external text-dark">
    <h1>{{ i18n[locale]['external_view'] }}</h1>
    <ul class="d-tabs">
      <li class="d-tabs__tab" @click="setTheActiveTab(0)" :class="{'d-tabs__tab--active': theActiveTab === 0}">
        {{ i18n[locale]['calendars'] }}
      </li>
      <li class="d-tabs__tab" @click="setTheActiveTab(1)" :class="{'d-tabs__tab--active': theActiveTab === 1}">
        {{ i18n[locale]['absent_today'] }}
      </li>
    </ul>
    <div class="box">
      <template v-if="theActiveTab === 1">
        <h2 class="marg-1-bottom">{{ i18n[locale]['show_absent_today'] }}</h2>
        <div class="absence-activate marg-1-bottom">
          <span>{{ i18n[locale]['activate_view'] }}</span>
          <div class="absence-activate__toggle" @click="toggleAbsentTodayView">
            <loader :isExtraSmall="true" style="margin: 0" bg-color="#fff" v-if="isAbsentTodaySaving"></loader>
            <app-toggle v-else :prop-on="isAbsentTodayEnabled" :allow-changes="false"></app-toggle>
          </div>
        </div>
        <template v-if="isAbsentTodayEnabled">
          <p class="marg-1-bottom">{{ i18n[locale]['show_absent_today_desc'] }}</p>
          <a :href="absence">{{ absence }}</a>
        </template>
      </template>
      <template v-if="theActiveTab === 0">
        <h2 class="marg-1-bottom">{{ i18n[locale]['show_selected_schedules'] }}</h2>
        <p>
          <span v-if="studentCalendars.length === 0">{{ i18n[locale]['show_selected_schedules_desc'] }}:</span>
          <span v-else>{{ i18n[locale]['show_selected_schedules_desc_with_students'] }}:</span>
          <br>
          <a class="marg-1-top" :href="publicLink" target="_blank">{{ publicLink }}</a>
        </p>
        <p>{{ i18n[locale]['use_update_in_url'] }}</p>
        <h4 class="marg-1-bottom marg-1-top" v-if="studentCalendars.length === 0">{{ i18n[locale]['selected_the_schedules'] }}</h4>
        <h4 class="marg-1-bottom marg-1-top" v-else>{{ i18n[locale]['selected_the_schedules_with_students'] }}</h4>
        <loader bg-color="#fff" style="margin: 100px 200px" v-if="isLoadingCalendars"></loader>
        <table class="d-table marg-2-top external__toggle-calendars" v-else>
          <thead class="d-table__header">
          <th></th>
          <th>
            <div class="inline-block"
                 :content="i18n[locale]['access_schedule_without_login']"
                 v-tippy="{
            arrow: true
          }">
              {{ i18n[locale]['visible_via_link'] }} <span class="icon-question3"></span>
            </div>
          </th>
          <th>
            <div class="inline-block text-link pointer"
                 @click="setIsShowMobileGuide(true)"
                 :content="i18n[locale]['visible_via_link_tooltip']"
                 v-tippy="{
            arrow: true
          }">
              {{ i18n[locale]['schedules_on_desktop_mobile'] }} <span class="icon-question3"></span>
            </div>
          </th>
          <th>
            <div class="inline-block"
                 :content="i18n[locale]['schedules_on_desktop_mobile_tooltip']"
                 v-tippy="{
            arrow: true
          }">
              {{ i18n[locale]['show_schedules_until'] }} <span class="icon-question3"></span>
            </div>
          </th>
          <th>
            <div class="pointer inline-block text-link"
                 @click="setIsShowICalGuide(true)"
                 :content="i18n[locale]['integrations_with_google']"
                 v-tippy="{
        arrow: true
      }">Google, Apple, Outlook <span class="icon-question3"></span></div>
          </th>
          </thead>
          <thead class="d-table__header d-table__header__first">
          <th class="th-hover" @click="isShowKlass = !isShowKlass">
            <span class="marg-1-right"
                  :class="[{'icon-arrow-up': isShowKlass}, {'icon-arrow-down': !isShowKlass}]"></span>
            {{ calendarsWithProps.length }}
            {{ calendarsWithProps.length !== 1 ? i18n[locale]['grade'] : i18n[locale]['grades'] }}
          </th>
          <th class="toggle-all-calendars">
            <template v-if="isShowKlass">
              <loader :isExtraSmall="true" style="margin: 0" bg-color="#f6f9fc"
                      v-if="isToggleLoading === 'klass'"></loader>
              <div @click.stop="toggleAllKlassCalendars" class="pointer" v-else>
                <span v-if="isAnyKlassCalendarsWithAnonymousAccess">{{ i18n[locale]['unselect'] }}</span><span
                v-else>{{ i18n[locale]['select'] }}</span> {{ i18n[locale]['all'] }}
              </div>
            </template>
          </th>
          <th></th>
          <th></th>
          <th></th>
          </thead>
          <tbody v-if="isShowKlass">
          <tr v-if="calendarsWithProps.length < 1">
            <td class="text-explainer" style="padding: 8px">{{ i18n[locale]['no_grades_created'] }}</td>
          </tr>
          <template v-for="calendar in calendarsWithProps">
            <tr :key="calendar.id" :class="{'tr-calendar--is-open': calendar.v_is_open}">
              <td :class="{'name-and-toggle': calendar.students && calendar.students.length > 0}"
                  @click="setActiveKlassCalendar(calendar)">
                <div class="d-toggle-arrow" v-if="calendar.students && calendar.students.length > 0"></div>
                {{ calendar.name }}
              </td>
              <td>
                <div class="inline-block" @click="toggleAnonymousAccess(calendar)">
                  <app-toggle :prop-on="calendar.anonymous_access" :allow-changes="false"></app-toggle>
                </div>
              </td>
              <td>
                <button class="bttn bttn--white bttn--small"
                        v-if="calendar.anonymous_access"
                        @click="copyToClipboard(calendar.v_public_link, $event)"
                        :content="i18n[locale]['copied'] + ' ' + calendar.v_public_link"
                        v-tippy="{
                    onShow: hideTippy,
                    trigger: 'manual',
                    arrow: true,
                    placement : 'top',
                    zIndex: 2147483010
                  }">{{ i18n[locale]['copy_calendar_link'] }}
                </button>
              </td>
              <td style="width: 400px">
                <!-- No Date -->
                <div v-if="!calendar.published_until && theActiveDatePickerId !== calendar.id"
                     class="calendar__no-end-date">
                  <p class="text-explainer">{{ i18n[locale]['no_end_date'] }}</p>
                  <div class="hint--right" :aria-label="i18n[locale]['set_a_date']"
                       @click="setActiveDatePicker(calendar)">
                    <div class="icon__bg-circle"><span class="icon-calendar4"></span></div>
                  </div>
                </div>
                <div class="calendar__datepicker-container" v-if="theActiveDatePickerId === calendar.id">
                  <DateSelector
                    :date="theActiveDatePickerDate"
                    :isOpen="true"
                    style="width: 210px;"
                    @changed="updatePublishUntilDate(calendar, $event)"
                    @close="closeDatepicker(calendar)">
                  </DateSelector>
                  <button class="bttn bttn-danger calendar__datepicker-container__button"
                          v-if="calendar.published_until"
                          @click="deleteActiveDatePicker(calendar)">{{ i18n[locale]['remove_end_date'] }}
                  </button>
                </div>
                <div class="calendar__datepicker-container calendar__datepicker-container--has-date"
                     v-if="calendar.published_until && theActiveDatePickerId !== calendar.id">
                  <div class="datepicker-input pointer pos-relative"
                       @click="setActiveDatePicker(calendar)">
                    <input id="inputfield"
                           type="text"
                           readonly
                           v-model="calendar.v_formatted_date"
                    />
                    <div class="icon-calendar4 input-icon"></div>
                  </div>
                </div>
              </td>
              <td>
                <button class="bttn bttn--white bttn--small"
                        @click="copyToClipboard(calendar.v_ical_link, $event)"
                        :content="i18n[locale]['copied'] + ' ' + calendar.v_ical_link"
                        v-tippy="{
                    onShow: hideTippy,
                    trigger: 'manual',
                    arrow: true,
                    placement : 'top',
                    zIndex: 2147483010
                  }">{{ i18n[locale]['copy_ical_link'] }}
                </button>
              </td>
            </tr>
            <tr v-if="calendar.v_is_open" class="tr-student--tr-thead d-table__header">
              <th>{{ activeStudentCalenders.length }} <span
                v-if="activeStudentCalenders.length === 1">{{ i18n[locale]['student'] }}</span><span
                v-else>{{ i18n[locale]['students'] }}</span></th>
              <th class="toggle-all-calendars">
                <loader :isExtraSmall="true" style="margin: 0" bg-color="#f6f9fc"
                        v-if="isToggleLoading === 'students'"></loader>
                <div @click="toggleAllStudentCalendars" class="inline-block pointer" v-else>
                  <span v-if="isAnyActiveStudentCalendersWithAnonymousAccess">{{ i18n[locale]['unselect'] }}</span><span
                  v-else>{{ i18n[locale]['select'] }}</span> {{ i18n[locale]['all'] }}
                </div>
              </th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
            <tr v-for="(student, key) in activeStudentCalenders"
                class="tr-student--tr"
                :class="{'tr-student--tr-thead--first': activeStudentCalenders.length > 1 && key === 0}"
                :key="student.id"
                v-if="calendar.v_is_open">
              <td>
                {{ student.name }}
              </td>
              <td>
                <div class="inline-block" @click="toggleAnonymousAccess(student)">
                  <app-toggle :prop-on="student.anonymous_access" :allow-changes="false"></app-toggle>
                </div>
              </td>
              <td>
                <button class="bttn bttn--white bttn--small"
                        v-if="student.anonymous_access"
                        @click="copyToClipboard(student.v_public_link, $event)"
                        :content="i18n[locale]['copied'] + ' ' + student.v_public_link"
                        v-tippy="{
                    onShow: hideTippy,
                    trigger: 'manual',
                    arrow: true,
                    placement : 'top',
                    zIndex: 2147483010
                  }">{{ i18n[locale]['copy_calendar_link'] }}
                </button>
              </td>
              <td style="width: 400px">
                <!-- No Date -->
                <div v-if="!student.published_until && theActiveDatePickerId !== student.id"
                     class="calendar__no-end-date">
                  <p class="text-explainer">{{ i18n[locale]['no_end_date'] }}</p>
                  <div class="hint--right" :aria-label="i18n[locale]['set_a_date']"
                       @click="setActiveDatePicker(student)">
                    <div class="icon__bg-circle"><span class="icon-calendar4"></span></div>
                  </div>
                </div>
                <div class="calendar__datepicker-container" v-if="theActiveDatePickerId === student.id">
                  <DateSelector
                    :date="theActiveDatePickerDate"
                    :isOpen="true"
                    style="width: 210px;"
                    @changed="updatePublishUntilDate(student, $event)"
                    @close="closeDatepicker(student)">
                  </DateSelector>
                  <button class="bttn bttn-danger calendar__datepicker-container__button"
                          v-if="student.published_until"
                          @click="deleteActiveDatePicker(student)">{{ i18n[locale]['remove_end_date'] }}
                  </button>
                </div>
                <div class="calendar__datepicker-container calendar__datepicker-container--has-date"
                     v-if="student.published_until && theActiveDatePickerId !== student.id">
                  <div class="datepicker-input pointer pos-relative"
                       @click="setActiveDatePicker(student)">
                    <input type="text"
                           readonly
                           v-model="student.v_formatted_date"
                    />
                    <div class="icon-calendar4 input-icon"></div>
                  </div>
                </div>
              </td>
              <td>
                <button class="bttn bttn--white bttn--small"
                        @click="copyToClipboard(student.v_ical_link, $event)"
                        :content="i18n[locale]['copied'] + ' ' + student.v_ical_link"
                        v-tippy="{
                    onShow: hideTippy,
                    trigger: 'manual',
                    arrow: true,
                    placement : 'top',
                    zIndex: 2147483010
                  }">{{ i18n[locale]['copy_ical_link'] }}
                </button>
              </td>
            </tr>
          </template>
          </tbody>
          <thead class="d-table__header d-table__header__first">
          <th class="th-hover" @click="isShowRooms = !isShowRooms">
            <span class="marg-1-right"
                  :class="[{'icon-arrow-up': isShowRooms}, {'icon-arrow-down': !isShowRooms}]"></span>
            {{ roomCalendarsWithProps.length }}
            {{ roomCalendarsWithProps.length !== 1 ? i18n[locale]['rooms'] : i18n[locale]['room'] }}
          </th>
          <th class="toggle-all-calendars">
            <template v-if="isShowRooms">
              <loader :isExtraSmall="true" style="margin: 0" bg-color="#f6f9fc"
                      v-if="isToggleLoading === 'rooms'"></loader>
              <div @click.stop="toggleAllRoomCalendars" class="pointer" v-else>
                <span v-if="isAnyRoomCalendarsWithAnonymousAccess">{{ i18n[locale]['unselect'] }}</span><span
                v-else>{{ i18n[locale]['select'] }}</span> {{ i18n[locale]['all'] }}
              </div>
            </template>
          <th></th>
          <th></th>
          <th></th>
          </thead>
          <tbody v-if="isShowRooms">
          <tr v-if="roomCalendarsWithProps.length < 1">
            <td class="text-explainer" style="padding: 8px">{{ i18n[locale]['no_rooms_created'] }}</td>
          </tr>
          <tr v-for="calendar in roomCalendarsWithProps" :key="calendar.id">
            <td><span class="icon-location"></span> {{ calendar.name }}</td>
            <td>
              <div class="inline-block" @click="toggleAnonymousAccess(calendar)">
                <app-toggle :prop-on="calendar.anonymous_access" :allow-changes="false"></app-toggle>
              </div>
            </td>
            <td>
              <button class="bttn bttn--white bttn--small"
                      v-if="calendar.anonymous_access"
                      @click="copyToClipboard(calendar.v_public_link, $event)"
                      :content="i18n[locale]['copied'] + ' ' + calendar.v_public_link"
                      v-tippy="{
                    onShow: hideTippy,
                    trigger: 'manual',
                    arrow: true,
                    placement : 'top',
                    zIndex: 2147483010
                  }">{{ i18n[locale]['copy_calendar_link'] }}
              </button>
            </td>
            <td style="width: 400px">
              <!-- No Date -->
              <div v-if="!calendar.published_until && theActiveDatePickerId !== calendar.id"
                   class="calendar__no-end-date">
                <p class="text-explainer">{{ i18n[locale]['no_end_date'] }}</p>
                <div class="hint--right" :aria-label="i18n[locale]['set_a_date']"
                     @click="setActiveDatePicker(calendar)">
                  <div class="icon__bg-circle"><span class="icon-calendar4"></span></div>
                </div>
              </div>
              <div class="calendar__datepicker-container" v-if="theActiveDatePickerId === calendar.id">
                <DateSelector
                  :date="theActiveDatePickerDate"
                  :isOpen="true"
                  style="width: 210px;"
                  @changed="updatePublishUntilDate(calendar, $event)"
                  @close="closeDatepicker(calendar)">
                </DateSelector>
                <button class="bttn bttn-danger calendar__datepicker-container__button" v-if="calendar.published_until"
                        @click="deleteActiveDatePicker(calendar)">{{ i18n[locale]['remove_end_date'] }}
                </button>
              </div>
              <div class="calendar__datepicker-container calendar__datepicker-container--has-date"
                   v-if="calendar.published_until && theActiveDatePickerId !== calendar.id">
                <div class="datepicker-input pointer pos-relative"
                     @click="setActiveDatePicker(calendar)">
                  <input type="text"
                         readonly
                         v-model="calendar.v_formatted_date"
                  />
                  <div class="icon-calendar4 input-icon"></div>
                </div>
              </div>
            </td>
            <td>
              <button class="bttn bttn--white bttn--small"
                      @click="copyToClipboard(calendar.v_ical_link, $event)"
                      :content="i18n[locale]['copied'] + ' ' + calendar.v_ical_link"
                      v-tippy="{
                    onShow: hideTippy,
                    trigger: 'manual',
                    arrow: true,
                    placement : 'top',
                    zIndex: 2147483010
                  }">{{ i18n[locale]['copy_ical_link'] }}
              </button>
            </td>
          </tr>
          </tbody>
          <!-- USERS -->
          <thead class="d-table__header d-table__header__first">
          <th class="th-hover" @click="isShowUsers = !isShowUsers">
            <span class="marg-1-right"
                  :class="[{'icon-arrow-up': isShowUsers}, {'icon-arrow-down': !isShowUsers}]"></span>
            {{ userCalendarsWithProps.length }}
            {{ userCalendarsWithProps.length !== 1 ? i18n[locale]['users'] : i18n[locale]['user'] }}
          </th>
          <th class="toggle-all-calendars">
            <template v-if="isShowUsers">
              <loader :isExtraSmall="true" style="margin: 0" bg-color="#f6f9fc"
                      v-if="isToggleLoading === 'users'"></loader>
              <div @click.stop="toggleAllUsersCalendars" class="pointer" v-else>
                <span v-if="isAnyUserCalendarsWithAnonymousAccess">{{ i18n[locale]['unselect'] }}</span><span
                v-else>{{ i18n[locale]['select'] }}</span> {{ i18n[locale]['all'] }}
              </div>
            </template>
          <th></th>
          <th></th>
          <th></th>
          </thead>
          <tbody v-if="isShowUsers">
          <tr v-if="userCalendarsWithProps.length < 1">
            <td class="text-explainer" style="padding: 8px">{{ i18n[locale]['no_users_created'] }}</td>
          </tr>
          <tr v-for="calendar in userCalendarsWithProps" :key="calendar.id">
            <td><span class="icon-location"></span> {{ calendar.name }}</td>
            <td>
              <div class="inline-block" @click="toggleAnonymousAccess(calendar)">
                <app-toggle :prop-on="calendar.anonymous_access" :allow-changes="false"></app-toggle>
              </div>
            </td>
            <td>
              <button class="bttn bttn--white bttn--small"
                      v-if="calendar.anonymous_access"
                      @click="copyToClipboard(calendar.v_public_link, $event)"
                      :content="i18n[locale]['copied'] + ' ' + calendar.v_public_link"
                      v-tippy="{
                    onShow: hideTippy,
                    trigger: 'manual',
                    arrow: true,
                    placement : 'top',
                    zIndex: 2147483010
                  }">{{ i18n[locale]['copy_calendar_link'] }}
              </button>
            </td>
            <td style="width: 400px">
              <!-- No Date -->
              <div v-if="!calendar.published_until && theActiveDatePickerId !== calendar.id"
                   class="calendar__no-end-date">
                <p class="text-explainer">{{ i18n[locale]['no_end_date'] }}</p>
                <div class="hint--right" :aria-label="i18n[locale]['set_a_date']"
                     @click="setActiveDatePicker(calendar)">
                  <div class="icon__bg-circle"><span class="icon-calendar4"></span></div>
                </div>
              </div>
              <div class="calendar__datepicker-container" v-if="theActiveDatePickerId === calendar.id">
                <DateSelector
                  :date="theActiveDatePickerDate"
                  :isOpen="true"
                  style="width: 210px;"
                  @changed="updatePublishUntilDate(calendar, $event)"
                  @close="closeDatepicker(calendar)">
                </DateSelector>
                <button class="bttn bttn-danger calendar__datepicker-container__button" v-if="calendar.published_until"
                        @click="deleteActiveDatePicker(calendar)">{{ i18n[locale]['remove_end_date'] }}
                </button>
              </div>
              <div class="calendar__datepicker-container calendar__datepicker-container--has-date"
                   v-if="calendar.published_until && theActiveDatePickerId !== calendar.id">
                <div class="datepicker-input pointer pos-relative"
                     @click="setActiveDatePicker(calendar)">
                  <input type="text"
                         readonly
                         v-model="calendar.v_formatted_date"
                  />
                  <div class="icon-calendar4 input-icon"></div>
                </div>
              </div>
            </td>
            <td>
              <button class="bttn bttn--white bttn--small"
                      @click="copyToClipboard(calendar.v_ical_link, $event)"
                      :content="i18n[locale]['copied'] + ' ' + calendar.v_ical_link"
                      v-tippy="{
                    onShow: hideTippy,
                    trigger: 'manual',
                    arrow: true,
                    placement : 'top',
                    zIndex: 2147483010
                  }">{{ i18n[locale]['copy_ical_link'] }}
              </button>
            </td>
          </tr>
          </tbody>
          <!-- MERGE -->
          <thead class="d-table__header d-table__header__first">
          <th class="th-hover" @click="isShowMergeCalendars = !isShowMergeCalendars">
            <span class="marg-1-right"
                  :class="[{'icon-arrow-up': isShowMergeCalendars}, {'icon-arrow-down': !isShowMergeCalendars}]"></span>
            {{ mergeCalendarsWithProps.length }}
            {{ mergeCalendarsWithProps.length !== 1 ? i18n[locale]['merge_calendars'] : i18n[locale]['merge_calendar'] }}
          </th>
          <th class="toggle-all-calendars">
            <template v-if="isShowMergeCalendars">
              <loader :isExtraSmall="true" style="margin: 0" bg-color="#f6f9fc"
                      v-if="isToggleLoading === 'merge'"></loader>
              <div @click.stop="toggleAllMergeCalendars" class="pointer" v-else>
                <span v-if="isAnyMergeCalendarsWithAnonymousAccess">{{ i18n[locale]['unselect'] }}</span><span
                v-else>{{ i18n[locale]['select'] }}</span> {{ i18n[locale]['all'] }}
              </div>
            </template>
          <th></th>
          <th></th>
          <th></th>
          </thead>
          <tbody v-if="isShowMergeCalendars">
          <tr v-if="mergeCalendarsWithProps.length < 1">
            <td class="text-explainer" style="padding: 8px">{{ i18n[locale]['no_merge_created'] }}</td>
          </tr>
          <tr v-for="calendar in mergeCalendarsWithProps" :key="calendar.id">
            <td><span class="icon-clipboard2"></span> {{ calendar.name }}</td>
            <td>
              <div class="inline-block" @click="toggleAnonymousAccess(calendar)">
                <app-toggle :prop-on="calendar.anonymous_access" :allow-changes="false"></app-toggle>
              </div>
            </td>
            <td>
              <button class="bttn bttn--white bttn--small"
                      v-if="calendar.anonymous_access"
                      @click="copyToClipboard(calendar.v_public_link, $event)"
                      :content="i18n[locale]['copied'] + ' ' + calendar.v_public_link"
                      v-tippy="{
                    onShow: hideTippy,
                    trigger: 'manual',
                    arrow: true,
                    placement : 'top',
                    zIndex: 2147483010
                  }">{{ i18n[locale]['copy_calendar_link'] }}
              </button>
            </td>
            <td style="width: 400px">
              <!-- No Date -->
              <div v-if="!calendar.published_until && theActiveDatePickerId !== calendar.id"
                   class="calendar__no-end-date">
                <p class="text-explainer">{{ i18n[locale]['no_end_date'] }}</p>
                <div class="hint--right" :aria-label="i18n[locale]['set_a_date']"
                     @click="setActiveDatePicker(calendar)">
                  <div class="icon__bg-circle"><span class="icon-calendar4"></span></div>
                </div>
              </div>
              <div class="calendar__datepicker-container" v-if="theActiveDatePickerId === calendar.id">
                <DateSelector
                  :date="theActiveDatePickerDate"
                  :isOpen="true"
                  style="width: 210px;"
                  @changed="updatePublishUntilDate(calendar, $event)"
                  @close="closeDatepicker(calendar)">
                </DateSelector>
                <button class="bttn bttn-danger calendar__datepicker-container__button" v-if="calendar.published_until"
                        @click="deleteActiveDatePicker(calendar)">{{ i18n[locale]['remove_end_date'] }}
                </button>
              </div>
              <div class="calendar__datepicker-container calendar__datepicker-container--has-date"
                   v-if="calendar.published_until && theActiveDatePickerId !== calendar.id">
                <div class="datepicker-input pointer pos-relative"
                     @click="setActiveDatePicker(calendar)">
                  <input type="text"
                         readonly
                         v-model="calendar.v_formatted_date"
                  />
                  <div class="icon-calendar4 input-icon"></div>
                </div>
              </div>
            </td>
            <td>
              <button class="bttn bttn--white bttn--small"
                      @click="copyToClipboard(calendar.v_ical_link, $event)"
                      :content="i18n[locale]['copied'] + ' ' + calendar.v_ical_link"
                      v-tippy="{
                    onShow: hideTippy,
                    trigger: 'manual',
                    arrow: true,
                    placement : 'top',
                    zIndex: 2147483010
                  }">{{ i18n[locale]['copy_ical_link'] }}
              </button>
            </td>
          </tr>
          </tbody>
          <!-- MERGE END -->
          <!-- OTHER -->
          <thead class="d-table__header d-table__header__first">
          <th class="th-hover" @click="isShowOtherCalendars = !isShowOtherCalendars">
            <span class="marg-1-right"
                  :class="[{'icon-arrow-up': isShowOtherCalendars}, {'icon-arrow-down': !isShowOtherCalendars}]"></span>
            {{ otherCalendarsWithProps.length }}
            {{ otherCalendarsWithProps.length !== 1 ? i18n[locale]['other'] : i18n[locale]['other'] }}
          </th>
          <th class="toggle-all-calendars">
            <template v-if="isShowOtherCalendars">
              <loader :isExtraSmall="true" style="margin: 0" bg-color="#f6f9fc"
                      v-if="isToggleLoading === 'other'"></loader>
              <div @click.stop="toggleAllOtherCalendars" class="pointer" v-else>
                <span v-if="isAnyOtherCalendarsWithAnonymousAccess">{{ i18n[locale]['unselect'] }}</span><span
                v-else>{{ i18n[locale]['select'] }}</span> {{ i18n[locale]['all'] }}
              </div>
            </template>
          <th></th>
          <th></th>
          <th></th>
          </thead>
          <tbody v-if="isShowOtherCalendars">
          <tr v-if="otherCalendarsWithProps.length < 1">
            <td class="text-explainer" style="padding: 8px">{{ i18n[locale]['no_other_created'] }}</td>
          </tr>
          <tr v-for="calendar in otherCalendarsWithProps" :key="calendar.id">
            <td><span class="icon-clipboard2"></span> {{ calendar.name }}</td>
            <td>
              <div class="inline-block" @click="toggleAnonymousAccess(calendar)">
                <app-toggle :prop-on="calendar.anonymous_access" :allow-changes="false"></app-toggle>
              </div>
            </td>
            <td>
              <button class="bttn bttn--white bttn--small"
                      v-if="calendar.anonymous_access"
                      @click="copyToClipboard(calendar.v_public_link, $event)"
                      :content="i18n[locale]['copied'] + ' ' + calendar.v_public_link"
                      v-tippy="{
                    onShow: hideTippy,
                    trigger: 'manual',
                    arrow: true,
                    placement : 'top',
                    zIndex: 2147483010
                  }">{{ i18n[locale]['copy_calendar_link'] }}
              </button>
            </td>
            <td style="width: 400px">
              <!-- No Date -->
              <div v-if="!calendar.published_until && theActiveDatePickerId !== calendar.id"
                   class="calendar__no-end-date">
                <p class="text-explainer">{{ i18n[locale]['no_end_date'] }}</p>
                <div class="hint--right" :aria-label="i18n[locale]['set_a_date']"
                     @click="setActiveDatePicker(calendar)">
                  <div class="icon__bg-circle"><span class="icon-calendar4"></span></div>
                </div>
              </div>
              <div class="calendar__datepicker-container" v-if="theActiveDatePickerId === calendar.id">
                <DateSelector
                  :date="theActiveDatePickerDate"
                  :isOpen="true"
                  style="width: 210px;"
                  @changed="updatePublishUntilDate(calendar, $event)"
                  @close="closeDatepicker(calendar)">
                </DateSelector>
                <button class="bttn bttn-danger calendar__datepicker-container__button" v-if="calendar.published_until"
                        @click="deleteActiveDatePicker(calendar)">{{ i18n[locale]['remove_end_date'] }}
                </button>
              </div>
              <div class="calendar__datepicker-container calendar__datepicker-container--has-date"
                   v-if="calendar.published_until && theActiveDatePickerId !== calendar.id">
                <div class="datepicker-input pointer pos-relative"
                     @click="setActiveDatePicker(calendar)">
                  <input type="text"
                         readonly
                         v-model="calendar.v_formatted_date"
                  />
                  <div class="icon-calendar4 input-icon"></div>
                </div>
              </div>
            </td>
            <td>
              <button class="bttn bttn--white bttn--small"
                      @click="copyToClipboard(calendar.v_ical_link, $event)"
                      :content="i18n[locale]['copied'] + ' ' + calendar.v_ical_link"
                      v-tippy="{
                    onShow: hideTippy,
                    trigger: 'manual',
                    arrow: true,
                    placement : 'top',
                    zIndex: 2147483010
                  }">{{ i18n[locale]['copy_ical_link'] }}
              </button>
            </td>
          </tr>
          </tbody>
          <!-- OTHER END -->

          <!-- SFO -->
          <thead class="d-table__header d-table__header__first">
          <th class="th-hover" @click="isShowClubCalendars = !isShowClubCalendars">
            <span class="marg-1-right"
                  :class="[{'icon-arrow-up': isShowClubCalendars}, {'icon-arrow-down': !isShowClubCalendars}]"></span>
            {{ clubCalendarsWithProps.length }}
            {{ clubCalendarsWithProps.length !== 1 ? i18n[locale]['club'] : i18n[locale]['club'] }}
          </th>
          <th class="toggle-all-calendars">
            <template v-if="isShowClubCalendars">
              <loader :isExtraSmall="true" style="margin: 0" bg-color="#f6f9fc"
                      v-if="isToggleLoading === 'club'"></loader>
              <div @click.stop="toggleAllClubCalendars" class="pointer" v-else>
                <span v-if="isAnyClubCalendarsWithAnonymousAccess">{{ i18n[locale]['unselect'] }}</span><span
                v-else>{{ i18n[locale]['select'] }}</span> {{ i18n[locale]['all'] }}
              </div>
            </template>
          <th></th>
          <th></th>
          <th></th>
          </thead>
          <tbody v-if="isShowClubCalendars">
          <tr v-if="clubCalendarsWithProps.length < 1">
            <td class="text-explainer" style="padding: 8px">{{ i18n[locale]['no_club_created'] }}</td>
          </tr>
          <tr v-for="calendar in clubCalendarsWithProps" :key="calendar.id">
            <td><span class="icon-clipboard2"></span> {{ calendar.name }}</td>
            <td>
              <div class="inline-block" @click="toggleAnonymousAccess(calendar)">
                <app-toggle :prop-on="calendar.anonymous_access" :allow-changes="false"></app-toggle>
              </div>
            </td>
            <td>
              <button class="bttn bttn--white bttn--small"
                      v-if="calendar.anonymous_access"
                      @click="copyToClipboard(calendar.v_public_link, $event)"
                      :content="i18n[locale]['copied'] + ' ' + calendar.v_public_link"
                      v-tippy="{
                    onShow: hideTippy,
                    trigger: 'manual',
                    arrow: true,
                    placement : 'top',
                    zIndex: 2147483010
                  }">{{ i18n[locale]['copy_calendar_link'] }}
              </button>
            </td>
            <td style="width: 400px">
              <!-- No Date -->
              <div v-if="!calendar.published_until && theActiveDatePickerId !== calendar.id"
                   class="calendar__no-end-date">
                <p class="text-explainer">{{ i18n[locale]['no_end_date'] }}</p>
                <div class="hint--right" :aria-label="i18n[locale]['set_a_date']"
                     @click="setActiveDatePicker(calendar)">
                  <div class="icon__bg-circle"><span class="icon-calendar4"></span></div>
                </div>
              </div>
              <div class="calendar__datepicker-container" v-if="theActiveDatePickerId === calendar.id">
                <DateSelector
                  :date="theActiveDatePickerDate"
                  :isOpen="true"
                  style="width: 210px;"
                  @changed="updatePublishUntilDate(calendar, $event)"
                  @close="closeDatepicker(calendar)">
                </DateSelector>
                <button class="bttn bttn-danger calendar__datepicker-container__button" v-if="calendar.published_until"
                        @click="deleteActiveDatePicker(calendar)">{{ i18n[locale]['remove_end_date'] }}
                </button>
              </div>
              <div class="calendar__datepicker-container calendar__datepicker-container--has-date"
                   v-if="calendar.published_until && theActiveDatePickerId !== calendar.id">
                <div class="datepicker-input pointer pos-relative"
                     @click="setActiveDatePicker(calendar)">
                  <input type="text"
                         readonly
                         v-model="calendar.v_formatted_date"
                  />
                  <div class="icon-calendar4 input-icon"></div>
                </div>
              </div>
            </td>
            <td>
              <button class="bttn bttn--white bttn--small"
                      @click="copyToClipboard(calendar.v_ical_link, $event)"
                      :content="i18n[locale]['copied'] + ' ' + calendar.v_ical_link"
                      v-tippy="{
                    onShow: hideTippy,
                    trigger: 'manual',
                    arrow: true,
                    placement : 'top',
                    zIndex: 2147483010
                  }">{{ i18n[locale]['copy_ical_link'] }}
              </button>
            </td>
          </tr>
          </tbody>
          <!-- SFO END -->
        </table>
      </template>
    </div>
    <export-calendar
      :isShowButton="false"
      :isShowFromProp="isShowICalGuide"
      @close="setIsShowICalGuide(false)">
    </export-calendar>
    <CalendarOnMobileGuides
      :isShowFromProp="isShowMobileGuide"
      @close="setIsShowMobileGuide(false)">
    </CalendarOnMobileGuides>
  </div>
</template>

<script>
import AppToggle from '../common/AppToggle'
import DateSelector from '../datepicker/DateSelector'
import Loader from '../common/Loader'
import moment from 'moment'
import CalendarOnMobileGuides from '../ExportCalendar/CalendarOnMobileGuides'
import docendo from '../../docendo'

const I18N = {
  da: {
    external_view: 'Ekstern visning',
    calendars: 'Kalendere',
    absent_today: 'Dagens fraværende',
    show_absent_today: 'Vis dagens fraværende på infoskærm',
    show_absent_today_desc: 'Ønsker I at vise information om dagens fraværende på infoskærm, kan nedenstående link bruges til opsætningen.',
    activate_view: 'Aktiver visningen',
    show_selected_schedules: 'Vis udvalgte skemaer',
    show_selected_schedules_desc: 'For at vise skemaer til elever og forældre kan I linke til skemaerne direkte fra jeres hjemmeside med dette link',
    show_selected_schedules_desc_with_students: 'For at vise skemaer til klasser, elever og forældre kan du dele nedenstående link på skolens hjemmeside eller lignende. Individuelle elevskemaer vil ikke blive delt via dette fælles link, men kan deles via sit eget unikke link, som kan findes ved at klikke på klassen i listen nedenfor.',
    selected_the_schedules: 'Vælg hvilke kalendere som skal være synlige på hjemmesiden og via direkte link',
    selected_the_schedules_with_students: 'Vælg hvilke skemaer for klasser og lokaler, der skal være synlige via linket ovenfor, og hvilke skemaer for elever der kan deles via et unikt direkte link.',
    visible_via_link: 'Synlig via link',
    visible_via_link_tooltip: 'Et unikt link til kalenderen, som f.eks. elever og forældre kan tilgå uden at skulle logge ind i Docendo. Klik for at se guide for mobil.',
    schedules_on_desktop_mobile: 'Skema på desktop, iPad, Mobil',
    schedules_on_desktop_mobile_tooltip: 'Lektioner i kalenderen vil kun være synlige til og med denne dato. Hvis der ikke er sat en dato, vil alle lektioner blive vist.',
    show_schedules_until: 'Vis skemaer til og med',
    integrations_with_google: 'Integration med Apple Calendar, Google mfl. Klik for at se guide',
    grades: 'Klasser',
    grade: 'Klasse',
    unselect: 'Fravælg',
    select: 'Vælg',
    all: 'Alle',
    no_grades_created: 'Der er ikke oprettet nogen klasser',
    copy_calendar_link: 'Kopier kalenderlink',
    copied: 'Kopieret',
    no_end_date: 'Ingen slutdato. Alt vises.',
    set_a_date: 'Sæt en slutdato',
    remove_end_date: 'Fjern slutdato',
    copy_ical_link: 'Kopier iCal-link',
    room: 'Lokale',
    rooms: 'Lokaler',
    no_rooms_created: 'Der er ikke oprettet nogen lokaler',
    access_schedule_without_login: 'Skal kalenderen kunne tilgås via et unikt link uden login?',
    student: 'elev',
    students: 'elever',
    user: 'bruger',
    users: 'brugere',
    no_users_created: 'Der er ikke oprettet nogen brugere',
    other: 'Andre kalendere',
    no_other_created: 'Der er ikke oprettet nogen andre kalendere',
    club: 'SFO',
    no_club_created: 'Der er ikke oprettet nogen SFO kalendere',
    merge_calendars: 'Fletteskemaer',
    merge_calendar: 'Fletteskema',
    no_merge_created: 'Der er ikke oprettet nogen flettekalendere',
    use_update_in_url: 'Hvis du ønsker, at de offentlige skemaer automatisk skal hente lektioner hvert 5. minut, skal du tilføje ?update i slutningen af den offentlige URL-adresse.'
  },
  en: {
    external_view: 'External view',
    calendars: 'Calendars',
    absent_today: 'Todays absent teachers',
    show_absent_today: 'Show todays absent teachers',
    show_absent_today_desc: 'Use link below to display information about absent teachers on info screen.',
    activate_view: 'Activate the view',
    show_selected_schedules: 'Display selected calendars',
    show_selected_schedules_desc: 'To show calendars to students and parents, you can link to the calendars directly from your website with this link',
    show_selected_schedules_desc_with_students: 'To show schedules to students and parents, you can share the link below on the school\'s website or similar. Individual student schedules will not be shared via this common link, but can be shared via their own unique link, which can be found by clicking on the grade/group in the list below.',
    selected_the_schedules: 'Choose which calendars should be visible on the website and via direct public link',
    selected_the_schedules_with_students: 'Choose which schedules for grades/groups and rooms are to be visible via the link above, and which student schedules can be shared via a unique direct link.',
    visible_via_link: 'Visible via link',
    visible_via_link_tooltip: 'A unique link to the calendar, such as students and parents can access without having to log in to Docendo. Click to view mobile guide.',
    schedules_on_desktop_mobile: 'Schedules on desktop, iPad, mobile',
    schedules_on_desktop_mobile_tooltip: 'Lessons in the calendar will only be visible up to and including this date. If no date is set, all lessons will be displayed.',
    show_schedules_until: 'Show schedules until',
    integrations_with_google: 'Integration with Apple Calendar, Google, etc. Click to view guide',
    grades: 'Grades/groups',
    grade: 'Grade/group',
    unselect: 'Deselect',
    select: 'Select',
    all: 'All',
    no_grades_created: 'No grades/groups created',
    copy_calendar_link: 'Copy calendar link',
    copied: 'Copied',
    no_end_date: 'No end date. All lesson will be shown.',
    set_a_date: 'Set an end date',
    remove_end_date: 'Remove end date',
    copy_ical_link: 'Copy iCal-link',
    room: 'Room',
    rooms: 'Rooms',
    no_rooms_created: 'No rooms created',
    access_schedule_without_login: 'Make the calendar accessible via a unique link without login?',
    student: 'student',
    students: 'students',
    user: 'user',
    users: 'users',
    no_users_created: 'No users created',
    other: 'Other calendars',
    no_other_created: 'No other calendars are created',
    club: 'Club',
    no_club_created: 'No club calendars are created',
    merge_calendars: 'Merge Calendars',
    merge_calendar: 'Merge Calendar',
    no_merge_created: 'No merge calendars have been created',
    use_update_in_url: 'If you want the public schedules to automatically fetch lessons every 5 minutes, you need to add ?update at the end of the public URL address.'
  },
  nb: {
    external_view: 'Ekstern visning',
    calendars: 'Kalendere',
    absent_today: 'Dagens fraværende',
    show_absent_today: 'Vis dagens fraværende',
    show_absent_today_desc: 'Informasjon om dagens fraværende undervisere kan vises på f.eks infoskjerm. Bruk linken under til oppsetting.',
    activate_view: 'Aktiver visningen',
    show_selected_schedules: 'Vis valgte timeplaner',
    show_selected_schedules_desc: 'For å vise timeplaner til klasser, elever og foresatte, kan man dele linken under på skolens hjemmeside eller lignende. Individuelle elevtimeplaner vil ikke deles via denne felles linken, men kan deles via egen unik link, som man finner ved å trykke på klassen i listen under.',
    show_selected_schedules_desc_with_students: 'For å vise timeplaner til klasser, elever og foresatte, kan man dele linken under på skolens hjemmeside eller lignende. Individuelle elevtimeplaner vil ikke deles via denne felles linken, men kan deles via egen unik link, som man finner ved å trykke på klassen i listen under.',
    selected_the_schedules: 'Velg hvilke timeplaner for klasser og rom som skal være synlige via linken over, og hvilke timeplaner til elever som kan deles via unik direktelink.',
    selected_the_schedules_with_students: 'Velg hvilke timeplaner for klasser og rom som skal være synlige via linken over, og hvilke timeplaner til elever som kan deles via unik direktelink.',
    visible_via_link: 'Synlig via link',
    visible_via_link_tooltip: 'En unik lenke til kalenderen, som f.eks elever og foreldre kan få tilgang uten å måtte logge på Docendo. Klikk for å se mobilguide.',
    schedules_on_desktop_mobile: 'Timeplan på desktop, iPad, Mobil',
    schedules_on_desktop_mobile_tooltip: 'Leksjoner i kalenderen vil kun være synlige til og med denne datoen. Hvis ingen dato er satt, vil alle leksjoner vises.',
    show_schedules_until: 'Vis timeplaner til og med',
    integrations_with_google: 'Integrasjon med Apple Calendar, Google, etc. Klikk for å se veiledningen',
    grades: 'Klasser',
    grade: 'Klasse',
    unselect: 'Opphev',
    select: 'Velg',
    all: 'alle',
    no_grades_created: 'Der er ikke opprettet noen klasser',
    copy_calendar_link: 'Kopier kalenderlenken',
    copied: 'Kopiert',
    no_end_date: 'Ingen sluttdato. Alt vises.',
    set_a_date: 'Angi en sluttdato',
    remove_end_date: 'Fjern sluttdatoen',
    copy_ical_link: 'Kopier iCal-lenken',
    room: 'Rom',
    rooms: 'Rom',
    no_rooms_created: 'Der er ikke opprettet noen rom',
    access_schedule_without_login: 'Kalenderen skal være tilgjengelig via en unik lenke uten pålogging?',
    student: 'elev',
    students: 'elever',
    user: 'bruker',
    users: 'brukere',
    no_users_created: 'Der er ikke opprettet noen brukere',
    other: 'Andre kalendere',
    no_other_created: 'Der er ikke opprettet noen andre kalendere',
    club: 'SFO',
    no_club_created: 'Der er ikke opprettet noen SFO kalendere',
    merge_calendars: 'Fellestimeplaner',
    merge_calendar: 'Fellestimeplan',
    no_merge_created: 'Der er ikke opprettet noen fellestimeplaner',
    use_update_in_url: 'Hvis du vil at offentlige timeplaner automatisk skal hente leksjoner hvert 5. minutt, må du legge til ?update på slutten av den offentlige URL-adressen.'
  }
}
export default {
  components: {CalendarOnMobileGuides, Loader, AppToggle, DateSelector},
  props: {
    absence: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      theActiveKlassCalendar: null,
      isShowICalGuide: false,
      isShowMobileGuide: false,
      theActiveDatePickerId: null,
      theActiveDatepickerDate: null,
      isToggleLoading: '',
      theActiveTab: 0,
      isShowKlass: true,
      isShowRooms: false,
      isShowUsers: false,
      isShowOtherCalendars: false,
      isShowClubCalendars: false,
      isShowMergeCalendars: false,
      isAbsentTodayEnabled: false,
      isAbsentTodaySaving: false
    }
  },
  created () {
    this.loadAbsentTodayView()
  },
  watch: {
    isUpdatingCalendars (val) {
      if (!val) {
        this.isToggleLoading = ''
      }
    }
  },
  computed: {
    i18n () {
      return I18N
    },
    locale () {
      return window.USER && window.USER.language ? window.USER.language : 'da'
    },
    schoolId () {
      return this.$store.getters.schoolId
    },
    isUpdatingCalendars () {
      return this.$store.state.isUpdatingCalendars
    },
    activeSchoolYear () {
      return this.$store.state.localActivatedSchoolYear
    },
    isLoadingCalendars () {
      return this.$store.state.isLoadingSchoolCalenders
    },
    roomCalendars () {
      return this.$store.getters.roomCalendars
    },
    roomCalendarsWithProps () {
      return this.roomCalendars.map(calendar => {
        this.$set(calendar, 'v_public_link', this.generatePublicLink(calendar))
        this.$set(calendar, 'v_ical_link', window.location.origin + calendar.ical_link)
        this.$set(calendar, 'v_formatted_date', calendar.published_until ? moment(calendar.published_until).locale(window.USER.locale).format('DD. MMMM YYYY') : null)
        return calendar
      })
    },
    otherCalendars () {
      return this.$store.getters.otherCalendars
    },
    otherCalendarsWithProps () {
      return this.otherCalendars.map(calendar => {
        this.$set(calendar, 'v_public_link', this.generatePublicLink(calendar))
        this.$set(calendar, 'v_ical_link', window.location.origin + calendar.ical_link)
        this.$set(calendar, 'v_formatted_date', calendar.published_until ? moment(calendar.published_until).locale(window.USER.locale).format('DD. MMMM YYYY') : null)
        return calendar
      })
    },
    clubCalendars () {
      return this.$store.getters.clubCalendars
    },
    clubCalendarsWithProps () {
      return this.clubCalendars.map(calendar => {
        this.$set(calendar, 'v_public_link', this.generatePublicLink(calendar))
        this.$set(calendar, 'v_ical_link', window.location.origin + calendar.ical_link)
        this.$set(calendar, 'v_formatted_date', calendar.published_until ? moment(calendar.published_until).locale(window.USER.locale).format('DD. MMMM YYYY') : null)
        return calendar
      })
    },
    mergeCalendars () {
      return this.$store.getters.mergeCalendars
    },
    mergeCalendarsWithProps () {
      return this.mergeCalendars.map(calendar => {
        this.$set(calendar, 'v_public_link', this.generatePublicLink(calendar))
        this.$set(calendar, 'v_ical_link', window.location.origin + calendar.ical_link)
        this.$set(calendar, 'v_formatted_date', calendar.published_until ? moment(calendar.published_until).locale(window.USER.locale).format('DD. MMMM YYYY') : null)
        return calendar
      })
    },
    userCalendars () {
      return this.$store.getters.userCalendars
    },
    userCalendarsWithProps () {
      return this.userCalendars.map(calendar => {
        this.$set(calendar, 'v_public_link', this.generatePublicLink(calendar))
        this.$set(calendar, 'v_ical_link', window.location.origin + calendar.ical_link)
        this.$set(calendar, 'v_formatted_date', calendar.published_until ? moment(calendar.published_until).locale(window.USER.locale).format('DD. MMMM YYYY') : null)
        return calendar
      })
    },
    studentCalendars () {
      return this.$store.getters.studentCalendars
    },
    studentCalendarsWithProps () {
      return this.studentCalendars.map(calendar => {
        this.$set(calendar, 'v_public_link', this.generatePublicLink(calendar))
        this.$set(calendar, 'v_ical_link', window.location.origin + calendar.ical_link)
        this.$set(calendar, 'v_formatted_date', calendar.published_until ? moment(calendar.published_until).locale(window.USER.locale).format('DD. MMMM YYYY') : null)
        return calendar
      })
    },
    activeStudentCalenders () {
      return this.studentCalendarsWithProps.filter(student => student.klasses && student.klasses.indexOf(this.theActiveKlassCalendar) > -1)
    },
    calendars () {
      return this.$store.getters.klassCalendars
    },
    klassCalendarsWithAnonymousAccess () {
      return this.calendars.filter(calendar => calendar.anonymous_access)
    },
    isAnyKlassCalendarsWithAnonymousAccess () {
      return this.klassCalendarsWithAnonymousAccess.length > 0
    },
    roomCalendarsWithAnonymousAccess () {
      return this.roomCalendars.filter(calendar => calendar.anonymous_access)
    },
    isAnyRoomCalendarsWithAnonymousAccess () {
      return this.roomCalendarsWithAnonymousAccess.length > 0
    },
    otherCalendarsWithAnonymousAccess () {
      return this.otherCalendars.filter(calendar => calendar.anonymous_access)
    },
    isAnyOtherCalendarsWithAnonymousAccess () {
      return this.otherCalendarsWithAnonymousAccess.length > 0
    },
    clubCalendarsWithAnonymousAccess () {
      return this.clubCalendars.filter(calendar => calendar.anonymous_access)
    },
    isAnyClubCalendarsWithAnonymousAccess () {
      return this.clubCalendarsWithAnonymousAccess.length > 0
    },
    mergeCalendarsWithAnonymousAccess () {
      return this.mergeCalendars.filter(calendar => calendar.anonymous_access)
    },
    isAnyMergeCalendarsWithAnonymousAccess () {
      return this.mergeCalendarsWithAnonymousAccess.length > 0
    },
    userCalendarsWithAnonymousAccess () {
      return this.userCalendars.filter(calendar => calendar.anonymous_access)
    },
    isAnyUserCalendarsWithAnonymousAccess () {
      return this.userCalendarsWithAnonymousAccess.length > 0
    },
    activeStudentCalendersWithAnonymousAccess () {
      return this.activeStudentCalenders.filter(calendar => calendar.anonymous_access)
    },
    isAnyActiveStudentCalendersWithAnonymousAccess () {
      return this.activeStudentCalendersWithAnonymousAccess.length > 0
    },
    calendarsWithProps () {
      return this.calendars.map(calendar => {
        this.$set(calendar, 'v_is_open', this.theActiveKlassCalendar === calendar.id)
        this.$set(calendar, 'v_public_link', this.generatePublicLink(calendar))
        this.$set(calendar, 'v_ical_link', window.location.origin + calendar.ical_link)
        this.$set(calendar, 'v_formatted_date', calendar.published_until ? moment(calendar.published_until).locale(window.USER.locale).format('DD. MMMM YYYY') : null)
        return calendar
      })
    },
    publicLink () {
      return window.location.origin + '/schools/' + window.SCHOOL.id + '/public_calendars'
    }
  },
  methods: {
    generatePublicLink (calendar) {
      return window.location.origin + '/calendar/' + calendar.public_id
    },
    setActiveKlassCalendar (calendar) {
      if (calendar.students && calendar.students.length < 1) {
        return
      }
      if (this.theActiveKlassCalendar === calendar.id) {
        this.theActiveKlassCalendar = null
      } else {
        this.theActiveKlassCalendar = calendar.id
      }
    },
    setTheActiveTab (num) {
      this.theActiveTab = num
    },
    setActiveDatePicker (calendar) {
      if (calendar.published_until) {
        this.theActiveDatePickerDate = moment(calendar.published_until).format('YYYY-MM-DD')
      } else {
        this.theActiveDatePickerDate = moment(this.activeSchoolYear.student_time_end).format('YYYY-MM-DD')
      }
      this.theActiveDatePickerId = calendar.id
    },
    closeDatepicker (calendar) {
      this.theActiveDatePickerDate = null
      this.theActiveDatePickerId = null
    },
    updatePublishUntilDate (calendar, theDate) {
      let calendars = [{
        calendar_id: calendar.id,
        published_until: theDate,
        anonymous_access: calendar.anonymous_access
      }]
      this.$store.dispatch('updateSchoolCalendars', calendars)
      this.closeDatepicker()
    },
    deleteActiveDatePicker (calendar) {
      this.updatePublishUntilDate(calendar, null)
      this.closeDatepicker()
    },
    toggleAllKlassCalendars () {
      this.isToggleLoading = 'klass'
      let calendars = this.calendars
      if (this.isAnyKlassCalendarsWithAnonymousAccess) {
        calendars = this.klassCalendarsWithAnonymousAccess
      }
      let cals = calendars.map(calendar => {
        let cal = {
          calendar_id: calendar.id,
          published_until: calendar.published_until,
          anonymous_access: !this.isAnyKlassCalendarsWithAnonymousAccess
        }
        return cal
      })
      this.$store.dispatch('updateSchoolCalendars', cals)
    },
    toggleAllUsersCalendars () {
      this.isToggleLoading = 'users'
      let calendars = this.userCalendars
      if (this.isAnyUserCalendarsWithAnonymousAccess) {
        calendars = this.userCalendarsWithAnonymousAccess
      }
      const cals = calendars.map(calendar => {
        const cal = {
          calendar_id: calendar.id,
          published_until: calendar.published_until,
          anonymous_access: !this.isAnyUserCalendarsWithAnonymousAccess
        }
        return cal
      })
      this.$store.dispatch('updateSchoolCalendars', cals)
    },
    toggleAllRoomCalendars () {
      this.isToggleLoading = 'rooms'
      let calendars = this.roomCalendars
      if (this.isAnyRoomCalendarsWithAnonymousAccess) {
        calendars = this.roomCalendarsWithAnonymousAccess
      }
      let cals = calendars.map(calendar => {
        let cal = {
          calendar_id: calendar.id,
          published_until: calendar.published_until,
          anonymous_access: !this.isAnyRoomCalendarsWithAnonymousAccess
        }
        return cal
      })
      this.$store.dispatch('updateSchoolCalendars', cals)
    },
    toggleAllOtherCalendars () {
      this.isToggleLoading = 'other'
      let calendars = this.otherCalendars
      if (this.isAnyOtherCalendarsWithAnonymousAccess) {
        calendars = this.otherCalendarsWithAnonymousAccess
      }
      let cals = calendars.map(calendar => {
        let cal = {
          calendar_id: calendar.id,
          published_until: calendar.published_until,
          anonymous_access: !this.isAnyOtherCalendarsWithAnonymousAccess
        }
        return cal
      })
      this.$store.dispatch('updateSchoolCalendars', cals)
    },
    toggleAllClubCalendars () {
      this.isToggleLoading = 'club'
      let calendars = this.clubCalendars
      if (this.isAnyClubCalendarsWithAnonymousAccess) {
        calendars = this.clubCalendarsWithAnonymousAccess
      }
      let cals = calendars.map(calendar => {
        let cal = {
          calendar_id: calendar.id,
          published_until: calendar.published_until,
          anonymous_access: !this.isAnyClubCalendarsWithAnonymousAccess
        }
        return cal
      })
      this.$store.dispatch('updateSchoolCalendars', cals)
    },
    toggleAllMergeCalendars () {
      this.isToggleLoading = 'merge'
      let calendars = this.mergeCalendars
      if (this.isAnyMergeCalendarsWithAnonymousAccess) {
        calendars = this.mergeCalendarsWithAnonymousAccess
      }
      let cals = calendars.map(calendar => {
        let cal = {
          calendar_id: calendar.id,
          published_until: calendar.published_until,
          anonymous_access: !this.isAnyMergeCalendarsWithAnonymousAccess
        }
        return cal
      })
      this.$store.dispatch('updateSchoolCalendars', cals)
    },
    toggleAllStudentCalendars () {
      this.isToggleLoading = 'students'
      let calendars = this.activeStudentCalenders
      if (this.isAnyActiveStudentCalendersWithAnonymousAccess) {
        calendars = this.activeStudentCalendersWithAnonymousAccess
      }
      let cals = calendars.map(calendar => {
        let cal = {
          calendar_id: calendar.id,
          published_until: calendar.published_until,
          anonymous_access: !this.isAnyActiveStudentCalendersWithAnonymousAccess
        }
        return cal
      })
      this.$store.dispatch('updateSchoolCalendars', cals)
    },
    toggleAnonymousAccess (calendar) {
      let calendars = [{
        calendar_id: calendar.id,
        published_until: calendar.published_until,
        anonymous_access: !calendar.anonymous_access
      }]
      this.$store.dispatch('updateSchoolCalendars', calendars)
    },
    loadAbsentTodayView () {
      if (!this.schoolId) {
        return
      }
      docendo.showSchool(this.schoolId, data => {
        this.isAbsentTodayEnabled = !!data.anonymous_access
      })
    },
    toggleAbsentTodayView () {
      if (this.isAbsentTodaySaving || !this.schoolId) {
        return
      }
      const next = !this.isAbsentTodayEnabled
      this.isAbsentTodayEnabled = next
      this.isAbsentTodaySaving = true
      docendo.updateSchool(this.schoolId, {anonymous_access: next}, success => {
        this.isAbsentTodayEnabled = !!success.anonymous_access
        this.isAbsentTodaySaving = false
      }, failure => {
        console.log('failure', failure)
        this.isAbsentTodayEnabled = !next
        this.isAbsentTodaySaving = false
      })
    },
    setIsShowICalGuide (boolean) {
      this.isShowICalGuide = boolean
    },
    setIsShowMobileGuide (boolean) {
      this.isShowMobileGuide = boolean
    },
    hideTippy (tippyEl) {
      setTimeout(_ => {
        tippyEl.hide()
      }, 1000)
    },
    copyToClipboard (link, evt) {
      navigator.clipboard.writeText(link).then(_ => {
        /* clipboard successfully set */
        evt.target._tippy.show()
      }, _ => {
        /* clipboard write failed */
        console.log('that totally failed')
      })
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.d-table {
  background-color: #fff;
  width: 100%;
  border: 1px solid #e2e8f0;
  border-collapse: collapse;
}

.d-table__header {
  border: 1px solid #e2e8f0;
  text-transform: uppercase;
  font-weight: 700;
  text-align: left;
  background: #f6f9fc;
  color: #8898aa;
}

.d-table__header th,
.d-table td {
  padding: 0.5rem 1rem;
}

.d-table tbody tr:nth-child(2n) {
  background-color: #f9fafb;
}

.bttn.bttn--white {
  background: #ffffff;
}

.bttn.bttn--white:hover {
  background: #E4E4E4;
}

.bttn.bttn--small {
  font-size: 10px;
}

.calendar__no-end-date {
  display: flex;
  align-items: center;
}

.calendar__datepicker-container {
  display: flex;
  align-items: center;
}

.calendar__datepicker-container__button {
  height: auto;
  margin-left: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.input-icon {
  opacity: 0.5;
  position: absolute;
  top: 9px;
  right: 10px;
  font-size: 15px;
}

.datepicker-input:hover > input {
  border-color: var(--blue);
  cursor: pointer;
}

.toggle-all-calendars {
  font-size: 10px;
}

.toggle-all-calendars:hover {
  color: var(--blue);
}

.text-link:hover {
  color: var(--blue);
  text-decoration: underline;
}

.external a {
  color: var(--blue);
}

.external a:hover {
  text-decoration: underline;
}

.absence-activate {
  display: flex;
  align-items: center;
}

.absence-activate__toggle {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  margin-left: 0.75rem;
}

.d-tabs {
  display: flex;
  align-items: stretch;
}

.d-tabs__tab {
  border-radius: 4px 4px 0 0;
  padding: 1rem 2rem;
  margin-bottom: -2px;
  margin-right: 0;
  font-weight: bold;
  cursor: pointer;
  border-top: 2px solid transparent;
}

.d-tabs__tab.d-tabs__tab--active {
  background: #ffffff;
  border-top: 2px solid var(--blue);
}

.external ul {
  margin: 0;
}

.th-hover {
  cursor: pointer;
}

.th-hover:hover {
  color: var(--blue);
}

.d-toggle-arrow {
  width: 7px;
  height: 7px;
  border: 2px solid var(--dark-blue);
  border-width: 2px 2px 0 0;
  transform: rotate(45deg);
  margin-right: 1rem;
  transition: transform 0.25s;
  margin-top: -3px;
}

.tr-calendar--is-open .d-toggle-arrow {
  transform: rotate(135deg);
}

.name-and-toggle {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.name-and-toggle:hover {
  color: var(--blue)
}

.tr-calendar--is-open {
  box-shadow: 0 2px 2px 0 rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%), 0 1px 5px 0 rgb(0 0 0 / 20%);
}

.tr-student--tr-thead {
  box-shadow: 0 2px 2px 0 rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 0%), 0 1px 5px 0 rgb(0 0 0 / 0%);
  position: relative;
  background: #ffffff !important;
}

.tr-calendar--is-open,
.tr-student--tr,
.tr-student--tr-thead {
  border-left: 2px solid var(--blue);
}

.tr-student--tr {
  text-align: left;
  background: aliceblue !important;
}

.tr-student--tr:hover {
  background: #edf0f5 !important;
}

.tr-student--tr th {
  padding: 0.5rem 3rem;
}

.d-table tbody tr.tr-student--tr:not(.tr-student--tr-thead--first) {
  position: relative;
  box-shadow: 0 2px 2px 0 rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 0%), 0 1px 5px 0 rgb(0 0 0 / 0%);
}
</style>



// WEBPACK FOOTER //
// ExternalCalendars.vue?03cd9e25